export default __webpack_public_path__ + "static/media/ic-credit-card.c57597d8.svg";